export function formatNumber(value, decimals = null) {
    if (value === null || value === undefined || value === "")
        return "";
    const num = typeof value === "string" ? parseFloat(value) : value;
    if (isNaN(num))
        return String(value);
    const d = decimals !== null && decimals !== undefined
        ? Math.max(0, Math.min(decimals, 5))
        : null;
    // Format using 'de-DE' which gives 1.000,00 then replace , with .
    let formatted = new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: d !== null ? d : 0,
        maximumFractionDigits: d !== null ? d : 5,
    }).format(num);
    // If there's a comma (decimal), replace it with a dot.
    // Note: de-DE already uses dots for thousands, so we only need to change the decimal separator.
    return formatted.replace(",", ".");
}
